module.exports = __webpack_public_path__ + "static/out.332992b8.svg";